export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";

export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";

export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";


export const FETCH_OffersDATA_REQUEST = "FETCH_OffersDATA_REQUEST";

export const FETCH_OffersDATA_SUCCESS = "FETCH_OffersDATA_SUCCESS";

export const FETCH_OffersDATA_FAILURE = "FETCH_OffersDATA_FAILURE";


export const FETCH_BrandsDATA_REQUEST = "FETCH_BrandsDATA_REQUEST";

export const FETCH_BrandsDATA_SUCCESS = "FETCH_BrandsDATA_SUCCESS";

export const FETCH_BrandsDATA_FAILURE = "FETCH_BrandsDATA_FAILURE";



export const FETCH_ArticalsDATA_REQUEST = "FETCH__ArticalsDATA_REQUEST";

export const FETCH__ArticalsDATA_SUCCESS = "FETCH__ArticalsDATA_SUCCESS";

export const FETCH__ArticalsDATA_FAILURE = "FETCH__ArticalsDATA_FAILURE";


export const GET_SINGLE_PRODUCT_REQUEST = "GET_SINGLE_PRODUCT_REQUEST";

export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";

export const GET_SINGLE_PRODUCT_FAILURE = "GET_SINGLE_PRODUCT_FAILURE";




export const ADD_PRODUCT_CART_REQUEST = "ADD_PRODUCT_CART_REQUEST";

export const ADD_PRODUCT_CART_SUCCESS = "ADD_PRODUCT_CART_SUCCESS";

export const ADD_PRODUCT_CART_FAILURE = "ADD_PRODUCT_CART_FAILURE";






export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST";

export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";

export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE";





export const REMOVE_PRODUCT_CART_REQUEST = "REMOVE_PRODUCT_CART_REQUEST";

export const REMOVE_PRODUCT_CART_SUCCESS = "REMOVE_PRODUCT_CART_SUCCESS";

export const REMOVE_PRODUCT_CART_FAILURE = "REMOVE_PRODUCT_CART_FAILURE";




export const ADD_ORDER_REQUEST = "ADD_ORDER_REQUEST";

export const ADD_ORDER_SUCCESS = "ADD_ORDER_SUCCESS";

export const ADD_ORDER_FAILURE = "ADD_ORDER_FAILURE";





export const EMPTY_CART_REQUEST = "EMPTY_CART_REQUEST";

export const EMPTY_CART_SUCCESS = "EMPTY_CART_SUCCESS";

export const EMPTY_CART_FAILURE = "EMPTY_CART_FAILURE";




export const FETCH_ORDERS_REQUEST = "FETCH_ORDERS_REQUEST";

export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";

export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";
